import { render, staticRenderFns } from "./r-level-track-reward-dialog.vue?vue&type=template&id=f3bc94b0&scoped=true"
import script from "./r-level-track-reward-dialog.vue?vue&type=script&lang=js"
export * from "./r-level-track-reward-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-level-track-reward-dialog.vue?vue&type=style&index=0&id=f3bc94b0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bc94b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3bc94b0')) {
      api.createRecord('f3bc94b0', component.options)
    } else {
      api.reload('f3bc94b0', component.options)
    }
    module.hot.accept("./r-level-track-reward-dialog.vue?vue&type=template&id=f3bc94b0&scoped=true", function () {
      api.rerender('f3bc94b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/level-track/reward/r-level-track-reward-dialog.vue"
export default component.exports